import { render, staticRenderFns } from "./houseprice.vue?vue&type=template&id=560dddc6&scoped=true&"
import script from "./houseprice.vue?vue&type=script&lang=js&"
export * from "./houseprice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560dddc6",
  null
  
)

export default component.exports